import React, { useEffect } from "react";
import { Clapperboard, Loader2, RefreshCw } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PUBLIC_VIDEO_BRAND, VIDEO_LIBRARY_PATH } from "@/lib/publicTutorials";
import { useMgmtBrand } from "@/lib/useMgmtBrand";
import "@/styles/public-videos.css";

export const PublicVideoShell = ({ title = "Video library", children }) => {
  useMgmtBrand(`${title} — ${PUBLIC_VIDEO_BRAND}`);
  useEffect(() => {
    const robots = document.createElement("meta");
    robots.name = "robots"; robots.content = "noindex, nofollow, noarchive";
    document.head.appendChild(robots);
    return () => robots.remove();
  }, []);
  return <div className="public-videos" data-testid="public-videos-shell">
    <header className="pv-masthead"><div className="pv-container">
      <Link to={VIDEO_LIBRARY_PATH} className="pv-brand" data-testid="video-library-brand-link">
        <span className="pv-brand-icon"><Clapperboard size={23} /></span>
        <span data-testid="video-library-brand">{PUBLIC_VIDEO_BRAND}</span>
      </Link>
      <span className="pv-masthead-label" data-testid="video-library-masthead-label">Tutorials</span>
    </div></header>
    <main className="pv-container pv-main" data-testid="public-videos-main">{children}</main>
    <footer className="pv-container pv-footer" data-testid="video-library-footer">{PUBLIC_VIDEO_BRAND} · Video library</footer>
  </div>;
};

export const PublicVideoState = ({ loading, error, missing, reload }) => <div className="pv-state" role={loading ? "status" : "alert"} data-testid="public-video-state">
  {loading ? <><Loader2 className="h-6 w-6 animate-spin" /><p data-testid="public-video-loading">Loading videos…</p></>
    : <><Clapperboard className="h-8 w-8" /><h2 data-testid="public-video-error-title">{missing ? "Video unavailable" : "Videos couldn’t load"}</h2>
      <p data-testid="public-video-error-message">{missing ? "This link is no longer available, or no video has been added yet." : error}</p>
      {missing ? <Button asChild variant="outline"><Link to={VIDEO_LIBRARY_PATH} data-testid="unavailable-back-to-videos">Back to videos</Link></Button>
        : <Button variant="outline" onClick={reload} data-testid="public-video-retry"><RefreshCw className="mr-2 h-4 w-4" />Try again</Button>}</>}
  </div>;